module.exports = __webpack_public_path__ + "6fb1a72d6c58083f1de577db4c222ebc.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icon-lock.svg
// module id = 97
// module chunks = 0